import { mapGetters, mapActions } from 'vuex'
import ExpertModule, { MODULE_NAME } from './index'

const ExpertMixin = {
  namespaced: ExpertModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(ExpertModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(ExpertModule.actions)) }
}

export default ExpertMixin



// WEBPACK FOOTER //
// ./src/store/module/expert/mixin.js